export default "__VITE_ASSET__DIPFwwe8__"